import { HttpClient } from '@angular/common/http';
import { Comment } from '@app/shared/models/post';
import { environment } from '@env/environment';
import { Observable, catchError, map, timeout } from 'rxjs';
import { ApiClientConfig } from '../api-client.config';
import { CommentsArrayResponse } from './api.comments.model';

export class CommentsApi {
  private apiUrl: string = environment.API_URL;
  COMMENTS = '/comments/comments';
  constructor(
    public readonly httpClient: HttpClient,
    public config: ApiClientConfig
  ) {}

  getCommentsByPostId(object_id: string, pageNum: number, pageSize: number): Observable<Comment[]> {
    return this.httpClient
      .get<CommentsArrayResponse>(
        `${this.apiUrl}${this.COMMENTS}/${object_id}?pageNum=${pageNum}&pageSize=${pageSize}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map((res: CommentsArrayResponse) => {
          return res.data;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  getCommentsByParentId(
    parentId: string,
    pageNum: number,
    pageSize: number
  ): Observable<Comment[]> {
    return this.httpClient
      .get<CommentsArrayResponse>(
        `${this.apiUrl}${this.COMMENTS}/${parentId}/replies?pageNum=${pageNum}&pageSize=${pageSize}`
      )
      .pipe(
        timeout(this.config.responseTimeout),
        map((res: CommentsArrayResponse) => {
          return res.data;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
